import script from "./OrderDragGame.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDragGame.vue?vue&type=script&setup=true&lang=js"

import "./OrderDragGame.vue?vue&type=style&index=0&id=61ef6712&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ef6712"]])

export default __exports__